<template>
  <modal :modal-key="'profile_change_pin_modal'" @close="$emit('close')" class="modal--welcomeback modal--zero-balance">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_change_login_pin_text }}</h1>
      <img class="pinicon" src="static/images/pin.svg" alt="">
    </template>
    <template slot="body">
      <form action="">
        <div :class="['form-group', !hasErrors ? '' : 'has-warning' ]">
          <input type="password"
                 v-model="passwordOld"
                 @keyup="validatePasswordOld()"
                 class="form-group__textfield phone_input"
                 :placeholder="getTranslations.home_modals_change_login_pin_enter_current" />
        </div>
        <div class="form-group">
          <input type="password"
                 v-model="passwordNew"
                 @keyup="validatePassword($event)"
                 class="form-group__textfield phone_input"
                 :placeholder="getTranslations.home_modals_change_login_pin_create_new" />
        </div>
        <div class="form-group sml_mrgn">
          <input type="password"
                 v-model="confirmPassword"
                 @keyup="validateConfirmation($event)"
                 class="form-group__textfield phone_input"
                 :placeholder="getTranslations.home_modals_change_login_pin_confirm" />
          <span class="form-group__feedback" v-if="hasErrors">
            {{ getMessage }}
          </span>
        </div>
        <div class="row login-bottom">
          <div class="col">
            <div class="login-form__forgot-password">
              <a style="cursor: pointer"
                 @click.prevent="goToForgot()">
                {{ getTranslations.home_modals_change_login_pin_forgot }}
              </a>
            </div>
          </div>
        </div>
        <input type="submit"
               :value="getTranslations.home_modals_change_login_pin_update"
               @click.prevent="changePin()"
               :class="['btn2 btn2--std btn2--small btn2--fixed', canProceed() ? '' : 'deactivated']">
        <div class="success_msg" v-show="success">
          <p>
            {{ getTranslations.home_profile_profile_edit_password_updated }}
          </p>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import ValidationMixin from '@/common/mixins/validations';

export default {
  name: 'change-pin',
  mixins: [ValidationMixin],
  components: {
    Modal,
  },
  methods: {
    ...mapActions('profile', [
      'logoutUserFromAuthorizedPages',
    ]),
    goToForgot() {
      this.$router.push({ name: 'profileForgotPassword1' });
    },
    canProceed() {
      return this.passwordOld && !this.hasErrors && this.passwordNew && this.confirmPassword;
    },
    changePin() {
      if (!this.canProceed()) {
        if (!this.resultMessage) this.setResult('home_profile_profile_edit_msg_warning_invalid_password');
        this.setError(true);
      } else {
        this.setResult('');
        this.$axios({
          url: 'api/changePassword',
          method: 'POST',
          headers: {
            Authorization: this.jwtInVuex,
          },
          data: {
            passwordOld: this.passwordOld,
            password: this.confirmPassword,
          },
        }).then((response) => {
          this.setResult('');
          this.setError(false);
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            this.setSuccess(true);
            this.setResult('home_profile_profile_edit_password_updated');
          } else if (response.data.responseEnum === 'SERVER_ERROR') {
            this.setError(true);
            this.setResult('home_profile_profile_edit_server_unvailable');
          } else {
            this.setResult('home_profile_profile_edit_msg_warning_invalid_password');
            this.setError(true);
          }
        }).catch((error) => {
          this.logoutUserFromAuthorizedPages();
          // eslint-disable-next-line
          console.log(`Invoking changePassword failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/profile/ChangePin.vue